import { useMemo } from 'react';
import { GeneralCatalogItem } from 'data-layer-cr/dist/models';
import { DisplayItem } from 'design-system';
import { useNetworkObserver } from 'data-layer-cr/dist/network';
// functions
import { mapCatatalogToDisplay as mapToDisplay } from 'src/functions/mapCatatalogToDisplay';
// store
import {
  BIRTH_PLACE_REQUEST,
  CIVIL_STATUS_REQUEST,
} from 'src/store/legalEntityCatalog/actions/legalEntityRequestIdentifiers';

type Props = {
  birthPlaces: GeneralCatalogItem[];
  civilStatus: GeneralCatalogItem[];
};

type HookResult = {
  requestingCivilStatus: boolean;
  requestingBirthPlaces: boolean;
  civilStatusOptions: DisplayItem[];
  birthPlaceOptions: DisplayItem[];
};

export default function useCivilInformation({
  birthPlaces,
  civilStatus,
}: Props): HookResult {
  const civilStatusRequestStatus = useNetworkObserver(CIVIL_STATUS_REQUEST);
  const birthPlaceRequestStatus = useNetworkObserver(BIRTH_PLACE_REQUEST);

  const civilStatusOptions = useMemo(
    () => mapToDisplay(civilStatus),
    [civilStatus],
  );
  const birthPlaceOptions = useMemo(
    () => mapToDisplay(birthPlaces),
    [birthPlaces],
  );

  return {
    requestingCivilStatus: civilStatusRequestStatus === 'requesting',
    requestingBirthPlaces: birthPlaceRequestStatus === 'requesting',
    civilStatusOptions,
    birthPlaceOptions,
  };
}
